import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import { font } from 'asserts/styles/fonts';

import DefaultButton from 'components/button/DefaultButton';
import { Modal } from 'antd';
interface GlobalModalProps {
  open: boolean;
  onCancel: () => void;
}

const BIzTypeModal = ({ onCancel, open }: GlobalModalProps) => {
  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={640}>
      <ModalWrapper>
        <Title>비즈니스 타입</Title>
        <ContentWrapper>
          <p>
            마이페이지 &gt; 계정정보 메뉴의 ‘엑스바디 비즈멤버십 가입정보’에서 확인 할 수 있습니다. 
          </p>

          <img src="/images/biz_type.png" alt="비즈니스 타입 이미지" loading="lazy" />
        </ContentWrapper>
        <ButtonWrapper>
          <DefaultButton onClick={onCancel} text="닫기" type="text" />
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
};

export default BIzTypeModal;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  border-radius: 16px;
`;

const Title = styled.h4`
  ${font.h4_medium};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    ${font.caption1_regular};
    color: ${color.black2};
  }

  & img {
    width: 576px;
    height: 300px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;

  p {
    text-align: center;
  }

  p button.ant-btn {
    color: ${color.black2};
    ${font.body_medium};
  }

  & p:first-of-type button {
    color: ${color.gray500};
  }
`;
